export const theme = {
  colors: {
    turquioze: "#1DB097",
    pink: "#E11452",
    offBlack: "#303030",
    orange: "#F29034",
  },
};
